const filterFeaturedPropertiesByOrigin = (featuredProperties, originCode) => {
  const getOriginsByOriginCode = (origins) =>
    origins ? origins.some((o) => o === originCode) : [];

  return originCode
    ? featuredProperties
        .filter(({ procuredOffer }) =>
          getOriginsByOriginCode(procuredOffer?.origins),
        )
        .filter(
          ({ propertyContent }) =>
            propertyContent.destination.destinationCode !== originCode,
        )
    : featuredProperties;
};

export default filterFeaturedPropertiesByOrigin;
